import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "cart",
  class: "frappe-card"
}
const _hoisted_2 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_3 = { class: "table" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", { scope: "col" }, null, -1 /* HOISTED */)
const _hoisted_5 = {
  id: "quantity",
  scope: "col"
}
const _hoisted_6 = {
  id: "start-date",
  scope: "col"
}
const _hoisted_7 = {
  id: "renewal-date",
  scope: "col"
}
const _hoisted_8 = {
  id: "free-limit-date",
  scope: "col"
}
const _hoisted_9 = {
  id: "price",
  scope: "col"
}
const _hoisted_10 = {
  id: "price",
  scope: "col"
}
const _hoisted_11 = {
  id: "total",
  scope: "col"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "empty-cart-message" }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "empty-cart-message" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.subscription.subscription_items.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("table", _hoisted_3, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _hoisted_4,
                _createElementVNode("th", _hoisted_5, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.__("Quantity")), 1 /* TEXT */)
                ]),
                _createElementVNode("th", _hoisted_6, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.__("Start Date")), 1 /* TEXT */)
                ]),
                _createElementVNode("th", _hoisted_7, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.__("Renewal Date")), 1 /* TEXT */)
                ]),
                _createElementVNode("th", _hoisted_8, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.__("Free Limit Date")), 1 /* TEXT */)
                ]),
                _createElementVNode("th", _hoisted_9, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.__("Setup and Purchase")), 1 /* TEXT */)
                ]),
                _createElementVNode("th", _hoisted_10, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.__("Unit Subscription")), 1 /* TEXT */)
                ]),
                _createElementVNode("th", _hoisted_11, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.__("Total Subscription")), 1 /* TEXT */)
                ])
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($setup.items_by_category), (category) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  ($setup.items_by_category[category].length)
                    ? (_openBlock(), _createBlock($setup["CartCategories"], {
                        category: category,
                        key: category
                      }, null, 8 /* PROPS */, ["category"]))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.items_by_category[category], (item) => {
                    return (_openBlock(), _createBlock($setup["CartItem"], {
                      key: item.name,
                      item: item,
                      users: $setup.number_of_users,
                      onMinusQty: _cache[0] || (_cache[0] = (i) => $setup.minusQty(i)),
                      onPlusQty: _cache[1] || (_cache[1] = (i) => $setup.plusQty(i)),
                      onRemoveItem: _cache[2] || (_cache[2] = (i) => $setup.removeItem(i))
                    }, null, 8 /* PROPS */, ["item", "users"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 64 /* STABLE_FRAGMENT */))
              }), 256 /* UNKEYED_FRAGMENT */)),
              _createVNode($setup["CartTotal"], {
                subscription_object: $props.subscription,
                carttype: $props.carttype
              }, null, 8 /* PROPS */, ["subscription_object", "carttype"]),
              ($props.carttype=='shopping-cart')
                ? (_openBlock(), _createBlock($setup["CartValidation"], {
                    key: 0,
                    subscription_object: $props.subscription,
                    onValidate_cart: _cache[3] || (_cache[3] = (vat_number, trial) => $setup.validate_cart(vat_number, trial))
                  }, null, 8 /* PROPS */, ["subscription_object"]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]))
      : ($props.carttype=='shopping-cart')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.__("Your shopping cart is empty")), 1 /* TEXT */)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.__("Select a product to start a new subscription")), 1 /* TEXT */)
            ])
          ]))
  ]))
}